import o from "./_development.js";
import r from "./_production.js";
import { IS_DEV as t } from "../lib/env.js";
import "./_base.js";
import "../onenav/is-in-onenav.js";
import "../onenav/routing.js";
import "cerulean/dist/lib/product";
import "../lib/location.js";
const a = t ? o : r;
export {
  a as default
};
//# sourceMappingURL=index.js.map
